import trouble_zg from './zg/router'
import trouble_cma from './cma/router'

export default [{
    path: 'trouble',
    name: 'trouble',
    component: r => require.ensure([], () => r(require('./index.vue')), 'trouble'),
    children: [
        trouble_zg,
        trouble_cma
    ]
}]
